import { getHeaders } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const chatAPI = createApi({
  reducerPath: 'chat',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getBorrowerChatHistory: builder.query({
      query: (userId) => ({
        url: `ai/chat/user-chats?user_id=${userId}`,
        method: 'GET',
        headers: getHeaders(),
      }),
    }),
    getChatMessages: builder.query({
      query: (chatId) => ({
        url: `ai/chat/chat-messages/${chatId}`,
        method: 'GET',
        headers: getHeaders(),
      }),
    }),
  }),
});

export const { useGetBorrowerChatHistoryQuery, useGetChatMessagesQuery } =
  chatAPI;
